import React from "react";
import "../../styles/ReportHeader.css";

const ReportHeader = ({ onRefresh, loading }) => {
    return (
        <div className="report-header">

            <div>
                <h1>Reports & Analytics</h1>

                <p>
                    Monitor revenue, orders, customers,
                    providers and business performance.
                </p>
            </div>

            <button
                className="refresh-btn"
                onClick={onRefresh}
                disabled={loading}
            >
                {loading ? "Refreshing..." : "Refresh"}
            </button>

        </div>
    );
};

export default ReportHeader;